(function() {
  var _addClass, clearTooltip, createTooltip, dom_utils, fancyValidation, fn, getTooltipPosition, hideAllTooltips, hot, j, known_cell_types, len, refreshAllTooltips, renderer, showTooltip, string_utils, validated_renderer,
    slice = [].slice;

  string_utils = App.load('core::utils/string');

  dom_utils = App.load('core::utils/dom');

  hot = window.Handsontable;

  _addClass = function(elem, class_name) {
    class_name = class_name.trim();
    if ((elem != null ? elem.className.indexOf(class_name) : void 0) === -1 && class_name.length) {
      return elem.className += ' ' + class_name;
    }
  };


  /*
  Functions to provide fancy validation handling to custom renderers.
  
  Check the source data for a `_{prop}_validation` attribute. If the value of
  `_{prop}_validation.status` is 'error', add a tooltip (using qTip2) to
  display the contents of `_{prop}_validation.message`. If not, clear it.
   */

  fancyValidation = function(instance, TD, row, col, prop, value, cellProperties) {
    var position, ref, validation;
    validation = (ref = instance.getSourceDataAtRow(row)) != null ? ref["_" + prop + "_validation"] : void 0;
    if (validation == null) {
      clearTooltip(TD);
      return;
    }
    switch (validation.status) {
      case 'invalid':
        position = getTooltipPosition(instance, col);
        createTooltip(TD, 'red', validation.message, position);
        return _addClass(TD, 'invalid');
      case 'incomplete':
        position = getTooltipPosition(instance, col);
        createTooltip(TD, 'cream', validation.message, position);
        return _addClass(TD, 'incomplete');
      default:
        return clearTooltip(TD);
    }
  };

  getTooltipPosition = function(instance, col) {
    if (col >= 6 && col >= (instance.countCols() - 2)) {
      return {
        my: 'top right',
        at: 'bottom left'
      };
    }
    return {
      my: 'top left',
      at: 'bottom right'
    };
  };

  createTooltip = function(elem, color, msg, position) {
    if (!msg) {
      msg = 'There was an unexpected problem with this cell';
    }
    $(elem).qtip({
      content: {
        text: msg
      },
      position: position,
      show: {
        ready: false,
        event: 'mouseenter click',
        solo: true
      },
      hide: {
        event: 'mouseleave',
        delay: 3000,
        effect: function() {
          return $(this).fadeOut();
        }
      },
      events: {
        render: function() {
          return this.on('click', function() {
            return $(elem).qtip('hide');
          });
        }
      },
      style: {
        classes: "qtip-" + color + " qtip-rounded qtip-shadow hdt-qtip"
      }
    });
    $(elem).closest('.hdt-hot').scroll((function(_this) {
      return function() {
        if (dom_utils.isVerticallyVisibleWithin(elem, '.hdt-hot')) {
          return $(elem).qtip('reposition');
        } else {
          return $(elem).qtip('hide');
        }
      };
    })(this));
    return $(elem).closest('.handsontable').scroll((function(_this) {
      return function() {
        if (dom_utils.isVerticallyVisibleWithin(elem, '.handsontable')) {
          return $(elem).qtip('reposition');
        } else {
          return $(elem).qtip('hide');
        }
      };
    })(this));
  };

  showTooltip = (function(_this) {
    return function(elem) {
      return $(elem).qtip('show');
    };
  })(this);

  clearTooltip = (function(_this) {
    return function(elem) {
      return $(elem).qtip('destroy', true);
    };
  })(this);

  refreshAllTooltips = (function(_this) {
    return function(instance) {
      var col, data, elems, j, len, prop, results, row, row_data;
      elems = $(instance.rootElement).find('td');
      clearTooltip(elems);
      data = instance.getData();
      results = [];
      for (row = j = 0, len = data.length; j < len; row = ++j) {
        row_data = data[row];
        results.push((function() {
          var k, ref, results1;
          results1 = [];
          for (col = k = 0, ref = instance.countCols() - 1; 0 <= ref ? k <= ref : k >= ref; col = 0 <= ref ? ++k : --k) {
            prop = instance.colToProp(col);
            results1.push(fancyValidation(instance, instance.getCell(row, col), row, col, prop, row_data[prop], instance.getCellMeta(row, col)));
          }
          return results1;
        })());
      }
      return results;
    };
  })(this);

  hideAllTooltips = (function(_this) {
    return function(instance) {
      var elems;
      elems = $(instance.rootElement).find('td');
      return $(elems).qtip('hide');
    };
  })(this);

  known_cell_types = ['text', 'numeric', 'checkbox', 'date', 'select', 'dropdown', 'autocomplete', 'password', 'handsontable', 'status'];

  fn = function(renderer) {
    return hot.renderers.registerRenderer(validated_renderer, function() {
      var params;
      params = 1 <= arguments.length ? slice.call(arguments, 0) : [];
      hot.renderers.getRenderer(renderer).apply(this, params);
      return fancyValidation.apply(this, params);
    });
  };
  for (j = 0, len = known_cell_types.length; j < len; j++) {
    renderer = known_cell_types[j];
    validated_renderer = 'validated' + string_utils.capitalize(renderer);
    fn(renderer);
  }

  hot.hooks.add('afterChange', function(changes, source) {
    var cellProperties, change, i, k, len1, old_val, prop, row, val;
    if (source === 'paste' || source === 'autofill') {
      for (i = k = 0, len1 = changes.length; k < len1; i = ++k) {
        change = changes[i];
        if ((change != null ? change.length : void 0) !== 4) {
          continue;
        }
        row = change[0], prop = change[1], old_val = change[2], val = change[3];
        cellProperties = this.getCellMeta(row, this.propToCol(prop));
        this.validateCell(val, cellProperties, (function(_this) {
          return function() {
            return void 0;
          };
        })(this));
      }
    }
    return changes;
  });

  hot.hooks.add('afterRemoveRow', function(row_start, amount) {
    return setTimeout((function(_this) {
      return function() {
        return refreshAllTooltips(_this);
      };
    })(this));
  });

  hot.hooks.add('afterSelectionEndByProp', function(row_start, col_start, row_end, col_end) {
    if (row_start === row_end && col_start === col_end) {
      hideAllTooltips(this);
      return showTooltip(this.getCell(row_start, col_start));
    }
  });

}).call(this);
